import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const Navdata = () => {
  const history = useNavigate();
  //state data
  const [isDashboard, setIsDashboard] = useState(false);
  const [isApps, setIsApps] = useState(false);
  const [isAuth, setIsAuth] = useState(false);
  const [isPages, setIsPages] = useState(false);
  const [isBaseUi, setIsBaseUi] = useState(false);
  const [isAdvanceUi, setIsAdvanceUi] = useState(false);
  const [isForms, setIsForms] = useState(false);
  const [isTables, setIsTables] = useState(false);
  const [isCharts, setIsCharts] = useState(false);
  const [isIcons, setIsIcons] = useState(false);
  const [isMaps, setIsMaps] = useState(false);
  const [isMultiLevel, setIsMultiLevel] = useState(false);

  //Calender
  // const [isCalender, setCalender] = useState(false);

  // Apps
  // const [isEmail, setEmail] = useState(false);
  // const [isSubEmail, setSubEmail] = useState(false);
  // const [isEcommerce, setIsEcommerce] = useState(false);
  // const [isProjects, setIsProjects] = useState(false);
  // const [isTasks, setIsTasks] = useState(false);
  // const [isCRM, setIsCRM] = useState(false);
  // const [isCrypto, setIsCrypto] = useState(false);
  // const [isInvoices, setIsInvoices] = useState(false);
  // const [isSupportTickets, setIsSupportTickets] = useState(false);
  // const [isNFTMarketplace, setIsNFTMarketplace] = useState(false);
  // const [isJobs, setIsJobs] = useState(false);
  // const [isJobList, setIsJobList] = useState(false);
  // const [isCandidateList, setIsCandidateList] = useState(false);

  // Authentication
  // const [isSignIn, setIsSignIn] = useState(false);
  // const [isSignUp, setIsSignUp] = useState(false);
  // const [isPasswordReset, setIsPasswordReset] = useState(false);
  // const [isPasswordCreate, setIsPasswordCreate] = useState(false);
  // const [isLockScreen, setIsLockScreen] = useState(false);
  // const [isLogout, setIsLogout] = useState(false);
  // const [isSuccessMessage, setIsSuccessMessage] = useState(false);
  // const [isVerification, setIsVerification] = useState(false);
  // const [isError, setIsError] = useState(false);

  // Pages
  // const [isProfile, setIsProfile] = useState(false);
  const [isLanding, setIsLanding] = useState(false);
  // const [isBlog, setIsBlog] = useState(false);

  // Charts
  // const [isApex, setIsApex] = useState(false);

  // Multi Level
  // const [isLevel1, setIsLevel1] = useState(false);
  // const [isLevel2, setIsLevel2] = useState(false);

  const [iscurrentState, setIscurrentState] = useState("Dashboard");

  function updateIconSidebar(e) {
    if (e && e.target && e.target.getAttribute("subitems")) {
      const ul = document.getElementById("two-column-menu");
      const iconItems = ul.querySelectorAll(".nav-icon.active");
      let activeIconItems = [...iconItems];
      activeIconItems.forEach((item) => {
        item.classList.remove("active");
        var id = item.getAttribute("subitems");
        if (document.getElementById(id))
          document.getElementById(id).classList.remove("show");
      });
    }
  }

  useEffect(() => {
    document.body.classList.remove("twocolumn-panel");
    if (iscurrentState !== "Dashboard") {
      setIsDashboard(false);
    }
    if (iscurrentState !== "Apps") {
      setIsApps(false);
    }
    if (iscurrentState !== "Auth") {
      setIsAuth(false);
    }
    if (iscurrentState !== "Pages") {
      setIsPages(false);
    }
    if (iscurrentState !== "BaseUi") {
      setIsBaseUi(false);
    }
    if (iscurrentState !== "AdvanceUi") {
      setIsAdvanceUi(false);
    }
    if (iscurrentState !== "Forms") {
      setIsForms(false);
    }
    if (iscurrentState !== "Tables") {
      setIsTables(false);
    }
    if (iscurrentState !== "Charts") {
      setIsCharts(false);
    }
    if (iscurrentState !== "Icons") {
      setIsIcons(false);
    }
    if (iscurrentState !== "Maps") {
      setIsMaps(false);
    }
    if (iscurrentState !== "MuliLevel") {
      setIsMultiLevel(false);
    }
    if (iscurrentState === "Widgets") {
      history("/widgets");
      document.body.classList.add("twocolumn-panel");
    }
    if (iscurrentState !== "Landing") {
      setIsLanding(false);
    }
  }, [
    history,
    iscurrentState,
    isDashboard,
    isApps,
    isAuth,
    isPages,
    isBaseUi,
    isAdvanceUi,
    isForms,
    isTables,
    isCharts,
    isIcons,
    isMaps,
    isMultiLevel,
  ]);

  const menuItems = [
    {
      label: "Menu",
      isHeader: true,
    },
  ];

  const overriddenMenuItems = [
    {
      label: "Menu",
      isHeader: true,
    },
    {
      id: "dashboard",
      label: "Dashboard",
      icon: "ri-dashboard-2-line",
      link: "/dashboard",
    },
    {
      id: "reports",
      label: "Reports",
      icon: "ri-bar-chart-2-line",
      link: "/#",
      stateVariables: isApps,
      click: function (e) {
        e.preventDefault();
        setIsApps(!isApps);
        setIscurrentState("Apps");
        updateIconSidebar(e);
      },
      subItems: [
        {
          id: "reports-clients",
          label: "Clients",
          link: "/reports/clients",
          parentId: "reports",
        },
        {
          id: "reports-ibRequests",
          label: "IB Requests",
          link: "/reports/ibRequests",
          parentId: "reports",
        },
        {
          id: "reports-client-accounts",
          label: "Client Accounts",
          link: "/reports/client-accounts",
          parentId: "reports",
        },
        {
          id: "reports-client-balances",
          label: "Client Balances",
          link: "/reports/client-balances",
          parentId: "reports",
        },
        {
          id: "reports-reward-history",
          label: "Reward History",
          link: "/reports/reward-history",
          parentId: "reports",
        },
        {
          id: "reports-client-transactions",
          label: "Client Transactions",
          link: "/reports/client-transactions",
          parentId: "reports",
        },
        {
          id: "reports-client-transactions-mt5",
          label: "Client Transactions MT5",
          link: "/reports/client-transactions-mt5",
          parentId: "reports",
        },
        {
          id: "reports-pending-payment",
          label: "Transactions Pending Payment",
          link: "/reports/transactions-pending-payment",
          parentId: "reports",
        },
        {
          id: "reports-performance-statistics",
          label: "Performance Statistics",
          link: "/reports/performance-statistics",
          parentId: "reports",
        },
      ],
    },
    {
      id: "rebates",
      label: "Rebates",
      icon: "ri-percent-line",
      link: "/rebates",
    },
    {
      id: "promo",
      label: "Promo",
      icon: "ri-megaphone-line",
      link: "/#",
      stateVariables: isBaseUi,
      click: function (e) {
        e.preventDefault();
        setIsBaseUi(!isBaseUi);
        setIscurrentState("BaseUi");
        updateIconSidebar(e);
      },
      subItems: [
        {
          id: "promo-materials",
          label: "Promo Materials",
          link: "/promo/materials",
          parentId: "promo",
        },
        {
          id: "promo-registration-tools",
          label: "Registration Tools",
          link: "/promo/registration-tools",
          parentId: "promo",
        },
        {
          id: "promo-mynt-overview",
          label: "Mynt Overview",
          link: "https://www.myntfx.com/",
          parentId: "promo",
          isExternal: true,
        },
        {
          id: "promo-advertising-guidelines",
          label: "Advertising Guidelines",
          link: "/promo/advertising-guidelines",
          parentId: "promo",
        },
      ],
    },
    {
      id: "support",
      label: "Support",
      icon: "ri-customer-service-2-line",
      link: "/#",
      stateVariables: isMultiLevel,
      click: function (e) {
        e.preventDefault();
        setIsMultiLevel(!isMultiLevel);
        setIscurrentState("MuliLevel");
        updateIconSidebar(e);
      },
      subItems: [
        {
          id: "support-help-center",
          label: "Help Center",
          link: "/support/help-center",
          parentId: "support",
        },
        {
          id: "support-contacts",
          label: "Contacts",
          link: "/support/contacts",
          parentId: "support",
        },
        {
          id: "support-legal",
          label: "Legal",
          link: "/support/legal",
          parentId: "support",
        },
      ],
    },
  ];

  return <React.Fragment>{overriddenMenuItems}</React.Fragment>;
};
export default Navdata;
